export class DbTables {
  USER: string = "users";
  COUNTRY: string = "country";
  STATE: string = "state";
  CITY: string = "city";
  PROPERTY: string = "property";
}
